$(document).ready(function () {
  // open active tab on page load
  if ($('.tabbed-accordion').length) {
    checkSize();
    $(window).resize(checkSize);

    $('.tabbed-accordion .accordion-title').on('click vclick keyup', '.tabbed-accordion .accordion-title', function (e) {
      if (!$(e.target).closest('.accordion-item').hasClass('is-active')) {
        var newHash = $(e.target).closest('.accordion-item').attr('id').replace('-label', '');

        if ($(window).width <= 1024) {
          history.replaceState(undefined, undefined, '#' + newHash);
        }

        openTab(newHash);
      } else {
        closeTab($(e.target));
      }
    });
    $('body').on('click vclick keyup', '.tabbed-accordion .tabs-title', function (e) {
      e.preventDefault();

      if (!$(e.target).closest('.tabs-title').hasClass('is-active')) {
        var newHash = $(e.target).closest('.tabs-title').find('> a').attr('href').replace('#', '');
        openTab(newHash);
      } else {
        closeTab($(e.target));
      }
    });

    var tabs = $('.tabbed-accordion .responsive-tabs').children();
    var tabIDs = [];

    var hash = window.location.hash.replace('#', '');

    tabs.each(function () {
      var id = $(this).attr('id').replace('-label', '');
      tabIDs.push(id);
    });

    if (hash && (tabIDs.indexOf(hash) != -1)) {
      openTab(hash);
    } else {
      // openTab(tabIDs[0]);
    }
  }

  // Go to tab when clicking a link with the class .go-to-tab...
  $('body').on('click', 'a.go-to-tab', function (e) {
    // e.preventDefault();
    $('.tabs-title a[href="' + $(this).attr('href') + '"]').click();
  });
});

function openTab(tab) {
  var navHeight = $('.nav--bottom').height() + $('.nav--top').height();
  // $('.toggleType.is-active').children('.tab-wrap:visible').css('display', 'none');
  // $('.toggleType.is-active, .tabs-title').removeClass('is-active');

  if ($(window).width() < 640) {
    $('#' + tab).closest('.tabs-to-accordions').find('.tab-wrap:visible').css('display', 'none');
  }
  $('#' + tab).closest('.tabs-to-accordions').find('.is-active').removeClass('is-active');
  if (!$('#' + tab + '-label').closest('.tabs').find('.tabs-title.is-active').length) {
    $('#' + tab).closest('.tabs-to-accordions').find('.tabs-title.' + tab).addClass('is-active');
    $('#' + tab + '-label').parent().addClass('is-active');
    $('#' + tab).addClass('is-active');

    if ($(window).width() < 640) {
      $('.toggleType.is-active').children('.tab-wrap').css('display', 'block');
    }

    if ($(window).width() <= 1024) {
      $('html, body').animate({
        scrollTop: $('#' + tab).closest('.accordion-item').offset().top - navHeight
      }, 250);
    }
  }

  $(window).resize();
}

function closeTab(tab) {
  tab.closest('.accordion-item').find('.tab-wrap:visible').css('display', 'none');
  tab.closest('.accordion-item').removeClass('is-active');
  history.replaceState(undefined, undefined, window.location.pathname);
}
/* https://codepen.io/derekshirk/pen/obGZPe */
function checkSize() {
  var rwd_tabs = $('.responsive-tabs');
  var toggl_type = $('.toggleType');
  var tab_wrap = $('.tab-wrap');
  if ($(".tabs-to-accordions").css("border-radius") == "0px") {
    if (rwd_tabs.hasClass('tabs-content')) {
      tab_wrap.css('display', 'none');
      rwd_tabs.removeClass('tabs-content');
      rwd_tabs.addClass('accordion');
      toggl_type.addClass('accordion-item');
      tab_wrap.addClass('accordion-content');
      rwd_tabs.attr('data-accordion');
      toggl_type.removeClass('tabs-panel');
      if ($('.toggleType.sis-active').length) {
        $('.toggleType.is-active').children('.tab-wrap').css('display', 'block');
      } else {
        $('.toggleType').first().children('.tab-wrap').css('display', 'block');
      }
    }
  } else {
    if (rwd_tabs.hasClass('accordion')) {
      rwd_tabs.removeAttr('data-accordion');
      rwd_tabs.removeClass('accordion');
      tab_wrap.removeClass('accordion-content');
      toggl_type.removeClass('accordion-item');
      rwd_tabs.addClass('tabs-content');
      toggl_type.addClass('tabs-panel');
      tab_wrap.css('display', '');
    }
  }
}